// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TPaNGD","wrapper--mobile":"XSC87r","message":"_16l_zU"};